import React from 'react'
import Fragment from '../common/fragment'

function FragmentAI(props) {
  return (
    <Fragment pos="i" {...props}>
      <p>
¿Son ovejas los robots?, ¿balan los androides?, ¿sueñan con ovejas eléctricas?
      </p>
    </Fragment>
  )
}


export default FragmentAI
